import React, { useState, useEffect, lazy, startTransition, Suspense } from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import LoginPage from "./components/pages/Login.jsx";
import RegisterPage from "./components/pages/Register.jsx";
import LottieLoader from "./lottie/lottie.jsx";

// Lazy load del TVChartContainer
const TVChartContainer = lazy(() =>
	import("./components/index").then((module) => ({
		default: module.default || module.TVChartContainer,
	}))
);

const App = () => {
	const [isAuthenticated, setAuthenticated] = useState(() => {
		return !!localStorage.getItem("token");
	});

	return (
		<Router>
			<ToastContainer />
			<Switch>
				<Route path="/login">{isAuthenticated ? <Redirect to="/chart" /> : <LoginPage setAuthenticated={setAuthenticated} />}</Route>
				<Route path="/register">{isAuthenticated ? <Redirect to="/chart" /> : <RegisterPage setAuthenticated={setAuthenticated} />}</Route>
				<PrivateRoute path="/chart" isAuthenticated={isAuthenticated}>
					<Suspense fallback={<LoadingScreen />}>
						<TVChartContainer />
					</Suspense>
				</PrivateRoute>

				<Redirect from="/" to={isAuthenticated ? "/chart" : "/login"} />
			</Switch>
		</Router>
	);
};

const LoadingScreen = () => (
	<div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
		<LottieLoader />
	</div>
);

const PrivateRoute = ({ children, isAuthenticated, ...rest }) => (
	<Route
		{...rest}
		render={({ location }) =>
			isAuthenticated ? (
				children
			) : (
				<Redirect
					to={{
						pathname: "/login",
						state: { from: location },
					}}
				/>
			)
		}
	/>
);

export default App;
